import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { getUsers, createUser, deleteUser } from '../../../../services/clients/users';

export const adminUsersQueryKeys = {
  all: ['adminUsers'],
  list: (clientId, params) => [...adminUsersQueryKeys.all, 'list', clientId, params],
};

export function useAdminUsersQuery(clientId, { page = 1, pageSize = 10 } = {}) {
  return useQuery({
    queryKey: adminUsersQueryKeys.list(clientId, { page, pageSize }),
    queryFn: () => getUsers({ clientId, page, pageSize }),
    enabled: Boolean(clientId),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

export function useCreateUser({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createUser,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: adminUsersQueryKeys.all });
      onSuccess?.(data, variables);
    },
    onError,
  });
}

export function useDeleteUser({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUser,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: adminUsersQueryKeys.all });
      onSuccess?.(data, variables);
    },
    onError,
  });
}
